import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ImportUslugaDto, UslugeClient } from '@kodit/core/data-api';
import { AlertService } from '@kodit/core/services';
import { FileUploadService } from '@kodit/core/shared-ui';
import * as XLSX from 'xlsx';

@Component({
  selector: 'kodit-usluge-import',
  templateUrl: './usluge-import.component.html',
  styleUrls: ['./usluge-import.component.scss'],
})
export class UslugeImportComponent implements OnInit {
  private _subs: Subscription = new Subscription();

  /** Props */
  uploadCompleted: boolean;
  readonly MAX_FILE_SIZE: number = 10000000;

  constructor(
    private _client: UslugeClient,
    private _alertService: AlertService,
    private _uploadService: FileUploadService
  ) {}

  ngOnInit(): void {
    this._uploadService.setMaxAttachmentSize = this.MAX_FILE_SIZE;
  }

  onUpload(file: File) {
    this.uploadCompleted = false;
    this._subs.add(
      this._client
        .import({
          data: file,
          fileName: '',
        })
        .subscribe(
          async (res) => {
            this.uploadCompleted = true;
            if (res.succeeded) {
              if (res.data.length != 0) {
                this.exportToExcel(res.data);
                this._alertService.addWarnMsg(
                  'Na Vašem računaru preuzet je novi Excel file sa uslugama čije podatke niste ispravno uneli. Ispravite ih i ponovo otpremite file.'
                );
                await new Promise((resolve) => setTimeout(resolve, 3000));
                location.reload();
              } else {
                this.uploadCompleted = true;
                this._alertService.addSuccessMsg('Uspešno su unete usluge.');
                await new Promise((resolve) => setTimeout(resolve, 2000));
                location.reload();
              }
            }
          },
          (error) => {
            this.uploadCompleted = true;
          }
        )
    );
  }

  exportToExcel = (roba: ImportUslugaDto[]) => {
    const workbook = XLSX.utils.book_new();
    const columns = [
      { field: 'sifra', header: 'Šifra' },
      { field: 'naziv', header: 'Naziv' },
      { field: 'jedinicaMere', header: 'Jedinica mere' },
      { field: 'pdv', header: 'PDV stopa(0, 10, 20)' },
      { field: 'vrednost', header: 'Vrednost' },
      { field: 'greska', header: 'Greška' },
    ];

    const worksheet1 = XLSX.utils.aoa_to_sheet([
      columns.map((col) => col.header),
      ...roba.map((row: { [x: string]: any }) =>
        columns.map((col) => row[col.field] || '')
      ),
    ]);

    XLSX.utils.book_append_sheet(workbook, worksheet1, 'neispravni_podaci');
    XLSX.writeFile(workbook, `neispravni-podaci.xlsx`);
  };

  downloadTemplate() {
    const link = document.createElement('a');
    link.setAttribute('target', '_blank');
    link.setAttribute(
      'href',
      '/assets/podesavanje/import_files/usluge_sablon.xls.xlsx'
    );
    link.setAttribute('download', 'usluge_sablon.xls.xlsx');
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  ngOnDestroy(): void {
    this._subs.unsubscribe();
  }
}
